module.exports = __webpack_public_path__ + "img/icon-home.199bf4fa.png";